export default __webpack_public_path__ + "static/media/icon-search.55fd26bb.svg";